import { useEffect, useState } from "react";
import { PublicShell } from "../components/PublicShell";
import { api } from "../lib/api";
import { Star } from "lucide-react";

export default function ReviewsPage() {
  const [reviews, setReviews] = useState([]);
  useEffect(() => { api.get("/reviews").then((r) => setReviews(r.data || [])); }, []);
  const avg = reviews.length ? (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1) : "—";
  return (
    <PublicShell>
      <section className="hero-bg pt-32 pb-16">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
          <div className="flex justify-center gap-1 mb-3">
            {Array.from({ length: 5 }).map((_, i) => <Star key={i} className="w-7 h-7 fill-[#D4AF37] text-[#D4AF37]" />)}
          </div>
          <div className="font-display text-6xl gold-text mb-3">{avg}</div>
          <div className="label-eyebrow">Out of 5 · {reviews.length} verified reviews</div>
          <h1 className="font-heading text-4xl sm:text-5xl mt-6"><span className="chrome-text">What our</span> <span className="gold-text">customers say.</span></h1>
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-6 lg:px-8 py-12 grid sm:grid-cols-2 lg:grid-cols-2 gap-5">
        {reviews.map((r) => (
          <div key={r.id} className="surface p-7 rounded-md" data-testid={`review-${r.id}`}>
            <div className="flex gap-0.5 mb-3">
              {Array.from({ length: r.rating }).map((_, i) => <Star key={i} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />)}
            </div>
            <div className="font-heading text-xl mb-3 chrome-text inline-block">{r.title}</div>
            <p className="text-slate-300 leading-relaxed">{r.body}</p>
            <div className="text-sm text-slate-500 mt-5">— {r.author}</div>
          </div>
        ))}
      </section>
    </PublicShell>
  );
}
